import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MtnaFormFieldWrappersModule, MtnaInlineEditorControlsModule } from '@mtna/core-angular';
import {
  MtnaOptionsToLanguageIdsPipeModule,
  MtnaI18nFocusIndicatorModule,
  MtnaOptionsToOtherLanguageIdsPipeModule,
} from '@mtna/core-i18n-angular';

import { RdsCI18nRichTextEditorComponent } from './i18n-wrapper.component';
import { RdsCRichTextEditorModule } from './rich-text-editor.module';

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    FlexLayoutModule,
    MtnaFormFieldWrappersModule,
    MtnaInlineEditorControlsModule,
    MtnaI18nFocusIndicatorModule,
    MtnaOptionsToLanguageIdsPipeModule,
    MtnaOptionsToOtherLanguageIdsPipeModule,
    RdsCRichTextEditorModule,
  ],
  declarations: [RdsCI18nRichTextEditorComponent],
  exports: [RdsCI18nRichTextEditorComponent, RdsCRichTextEditorModule],
})
export class RdsCI18nRichTextEditorModule {}
